<template>
  <v-app-bar dense app
    :color="$route.path.includes('h2p') ? '#ea776a' : ($route.path.includes('pfs') ? 'purple darken-1' : 'primary')"
    dark
             v-if="$route.name !== 'Login'"
  >
    <div class="d-flex align-center app-title">
      <v-app-bar-nav-icon @click.stop="sharedState.drawer = !sharedState.drawer"></v-app-bar-nav-icon>
      <v-img @click="returnHome" :src="require('@/assets/images/logo.svg')" width="198" class="ml-5"></v-img>
    </div>

    <v-breadcrumbs
      v-if="$route.meta && $route.meta.mapview"
      :items="sharedState.mapview.breadcrumbs"
    >
      <template v-slot:divider>
        <v-icon>mdi-chevron-right</v-icon>
      </template>
    </v-breadcrumbs>

    <v-breadcrumbs
      v-if="$route.meta && $route.meta.h2pmapview"
      :items="sharedState.h2pmapview.breadcrumbs"
    >
      <template v-slot:divider>
        <v-icon>mdi-chevron-right</v-icon>
      </template>
    </v-breadcrumbs>

    <v-spacer></v-spacer>
    <!-- <div>
      <v-btn class="mr-4" depressed light @click="sync"> データ同期</v-btn>
    </div> -->
    <div
      class="d-flex align-center app-title checkEnv mr-4"
      v-if="env != 'production'"
    >
      <span
        >こちらはステージング環境です。
        <p>
          本番環境は
          <a href="http://fileserver.afterfit.jp/" target="_blank"
            >http://fileserver.afterfit.jp/</a
          >
        </p>
      </span>
    </div>

    <v-btn
      v-if="$route.meta && $route.meta.mapview && sharedState.mapview.validColorTypes.length == 2"
      :color="sharedState.mapview.colorType == 'color' ? 'green' : 'grey'"
      class="switch-left"
      @click="changeMapViewColorType('color')"
    >
      可視
    </v-btn>
    <v-btn
      v-if="$route.meta && $route.meta.mapview && sharedState.mapview.validColorTypes.length == 2"
      :color="sharedState.mapview.colorType == 'thermal' ? 'orange' : 'grey'"
      class="switch-right mr-4"
      @click="changeMapViewColorType('thermal')"
    >
      サーモ
    </v-btn>

    <div class="d-flex align-center app-title mr-4">
      <v-menu v-if="$route.meta && $route.meta.mapview" offset-y :close-on-content-click="false" attach=".v-main">
        <template v-slot:activator="{ on, attrs }">
          <v-btn depressed v-bind="attrs" v-on="on" light>
            <span>メニュー</span>
          </v-btn>
        </template>
        <v-list>
          <v-list-item @click="createReport">
            <v-list-item-title>
              <v-icon left>mdi-file-chart</v-icon>
              <span>レポート</span>
            </v-list-item-title>
          </v-list-item>
          <v-list-item @click="onDownload">
            <v-list-item-title>
              <v-icon left>mdi-cloud-download</v-icon>
              <span>ダウンロード</span>
            </v-list-item-title>
          </v-list-item>
          <v-list-item @click="rerunODM" v-if="(sharedState.mapview.folder.app === 'opendronemap' || sharedState.mapview.folder.app === 'opendronemap_lightning') && sharedState.currentReportStatus === 'NEW'">
            <v-list-item-title>
              <v-icon left>mdi-autorenew</v-icon>
              <span>再構築</span>
            </v-list-item-title>
          </v-list-item>
          <!-- <v-list-item>
            <v-list-item-title>
              <v-menu
                bottom
                offset-x
                open-on-hover
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    depressed
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon left>mdi-vector-arrange-below</v-icon>
                    <span>ビューモード</span>
                  </v-btn>
                </template>

                <v-list>
                  <v-list-item
                    v-for="(item, index) in mapviewModes"
                    :key="index"
                  >
                    <v-list-item-title>{{ item.text }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>

            </v-list-item-title>
          </v-list-item> -->
        </v-list>
      </v-menu>
    </div>

    <v-btn class="mr-4" v-if="!$route.path.includes('h2p') && !$route.path.includes('pfs') && sharedState.email" depressed light @click="manual">
      <v-icon left>mdi-file-video</v-icon>
      <span>動画マニュアル</span>
    </v-btn>

    <v-menu v-if="sharedState.email" offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-btn text v-bind="attrs" v-on="on">
          <v-icon left>mdi-account</v-icon>
          <span>{{ sharedState.email.split("@")[0] }}</span>
        </v-btn>
      </template>
      <v-list>
        <v-list-item @click="logout">
          <v-list-item-title>
            <v-icon left>mdi-logout</v-icon>
            <span>ログアウト</span>
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>

    <data-download-dialog
      v-model="downloadDataDialog"
    ></data-download-dialog>
    <report-dialog v-model="reportDialog" v-if="reportDialog"></report-dialog>
    <odm-rerun-dialgo v-model="odmRerun" v-if="odmRerun" :folderId="$route.params.folderId"></odm-rerun-dialgo>
  </v-app-bar>
</template>

<script>
import {store} from "@/store";
import DataDownloadDialog from "../dialog/DataDownloadDialog";
import ReportDialog from "@/components/dialog/ReportDialog";
import ODMRerunDialog from "@/components/dialog/ODMRerunDialog";

export default {
  name: "AppBar",
  components: {
    "data-download-dialog": DataDownloadDialog,
    "report-dialog": ReportDialog,
    'odm-rerun-dialgo': ODMRerunDialog
  },
  data() {
    return {
      sharedState: store.state,
      env: process.env.VUE_APP_ENV,
      mapviewModes: [
        { text: "2Dモード", value: "2d" },
        { text: "3Dモード", value: "3d", disabled: true },
        // { text: "360°画像モード", value: "360", disabled: true },
      ],
      exportTypes: [
        { text: "ダウンロード", value: "download" },
        { text: "リンク共有", value: "link", disabled: true },
        // { text: "360°画像モード", value: "360", disabled: true },
      ],

      downloadDataDialog: false,
      reportDialog: false,
      drawer: false,
      odmRerun: false
    };
  },
  methods: {
    onDownload() {
      this.downloadDataDialog = true;
    },
    onShareLink() {
    },
    changeMapViewColorType(type) {
      store.changeMapViewColorType(type);
    },
    logout() {
      const token = this.sharedState.token;
      this.axios
        .post("/api/logout", { token: token })
        .then(() => {
          this.setLogoutStatus();
          this.$router.push("/login");
        })
        .catch(() => {
          alert("エラーが発生しました。再度試してください。");
        });
    },
    setLogoutStatus() {
      store.updateLogoutStatus();
      this.axios.defaults.headers.common["Authorization"] = "";
    },
    returnHome() {
      if(this.$route.path.includes("login")) {
        return;
      }else if(this.$route.path.includes("h2p")) {
        this.$router.push({
          path: '/h2p',
        });
      }else if(this.$route.path.includes("pfs")) {
        this.$router.push({
          path: '/pfs',
        });
      }
      else{
        this.$router.push({
          path: '/',
        });
      }
    },
    createReport(){
      this.reportDialog = true;

    },
    manual() {
      const link = 'https://drive.google.com/drive/u/1/folders/1R6XX8GJDPaOaz9oGlkD6LxI1SN7DspJT';
      window.open(link, "_blank");
    },
    // sync() {
    //   this.axios
    //         .get("/api/pfs/camera/")
    //         .then((response) => {
    //                 if (response.data === 1){
    //                   alert("データ同期が成功できた")
    //                 }else if(response.data === 2){
    //                   alert("データベースが最新に更新されました")
    //                 }
    //         })
    //         .catch(() => {
    //             store.showErrorDialog("エラーが発生しました。再度試してください。");
    //         });
    //   this.axios
    //         .get("/api/pfs/plan/")
    //         .then((response) => {
    //                 return response.data;
    //         })
    //         .catch(() => {
    //             store.showErrorDialog("エラーが発生しました。再度試してください。");
    //         });
    //   this.axios
    //         .get("/api/pfs/waypoint/")
    //         .then((response) => {
    //                 return response.data;
    //         })
    //         .catch(() => {
    //             store.showErrorDialog("エラーが発生しました。再度試してください。");
    //         });
    // },
    rerunODM(){
      this.odmRerun = true;
    }
  },

};
</script>

<style lang="scss">
.v-app-bar .theme--dark.v-select .v-select__selection--comma,
.v-app-bar .theme--dark.v-input.v-select,
.v-app-bar .v-select .theme--dark.v-icon {
  color: #333;
}
.v-app-bar .v-text-field.v-text-field--solo.v-input--dense > .v-input__control {
    min-height: 36px;
}
.v-app-bar .v-select.v-input {
  max-width: 170px;
}
.v-app-bar .v-toolbar__content {
  padding-left: 0px;
}
.v-text-field .v-select__selections > input {
  width: 0px;
}
.v-app-bar .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded) > .v-input__control > .v-input__slot {
  padding: 0px 10px;
}
.v-app-bar .v-text-field.v-text-field--solo .v-input__control input {
  display: none;
}
.v-app-bar .v-select.v-input--dense .v-select__selection--comma {
  margin-right: 0px;
}
.v-application--is-ltr .v-app-bar .v-text-field .v-input__append-inner {
  padding-left: 0px;
}
.v-app-bar .theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
    background-color: #fff;
}
.theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
  background-color: #fff;
}
.switch-left {
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
}
.switch-right {
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
}
</style>
